// extracted by mini-css-extract-plugin
module.exports = {"labels":"NotFound_labels__K8le4"};